<feed-image-modal [imageId]="data.imageId">
    <ng-template let-image="image">
        <image-metadata class="padleftright24 mbot16 db" [image]="image"></image-metadata>
        <image-feed-modal-annotation-section *ngIf="isCellDataWithAnnotation(image.cellData)" [cellData]="image.cellData"></image-feed-modal-annotation-section>
    </ng-template>
</feed-image-modal>